import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    // 工业互联网
    path: "/industry",
    name: "industry",
    component: () =>
      import(/* webpackChunkName: "industry" */ "@/components/InDusTry.vue"),
  },
  {
    // 智慧城市
    path: "/city",
    name: "city",
    component: () =>
      import(/* webpackChunkName: "city" */ "@/components/CityView.vue"),
  },
  {
    // 智慧停车
    path: "/park",
    name: "park",
    component: () =>
      import(/* webpackChunkName: "park" */ "@/components/ParkView.vue"),
  },
  {
    // 公司介绍
    path: "/info",
    name: "info",
    component: () =>
      import(/* webpackChunkName: "info" */ "@/components/InfoView.vue"),
  },
  {
    // 联系我们
    path: "/call",
    name: "call",
    component: () =>
      import(/* webpackChunkName: "call" */ "@/components/CallView.vue"),
  },
  // 任何不在路由表内的路由地址重定向到首页
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
